export default "__VITE_ASSET__da6656d2__"